import { helper } from '@ember/component/helper';
import type { GraphLine, GraphGeometry } from '../index.d.ts';
import { generateEnvelopeLower } from '../utils/graphUtils.ts';
//import { GraphLine, GraphGeometry } from '@ebiz/ember-aditools-graph/..';

export interface EnvelopeLowerSignature {
  Args: {
    Positional: [];
    Named: { line: GraphLine; geometry: GraphGeometry };
  };
  Return: string;
}

const envelopeLower = helper<EnvelopeLowerSignature>((params, { line, geometry }) => {
  return generateEnvelopeLower(line, geometry);
});

export default envelopeLower;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'envelope-lower': typeof envelopeLower;
  }
}
